const CACHE_PREFIX = "dynamicSchoolTheme";

function cacheKey(userKey) {
  return `${CACHE_PREFIX}:${userKey}`;
}

function read(userKey) {
  if (!userKey) return null;
  try {
    const rawValue = localStorage.getItem(cacheKey(userKey));
    if (!rawValue) return null;
    const cached = JSON.parse(rawValue);
    if (
      cached.schemaVersion !== 1 ||
      !cached.activeTheme ||
      cached.activeTheme.schema_version !== 1 ||
      !cached.activeTheme.config ||
      !Array.isArray(cached.activeTheme.layers)
    ) {
      remove(userKey);
      return null;
    }
    return cached;
  } catch (error) {
    remove(userKey);
    return null;
  }
}

function write(userKey, activeTheme, etag) {
  if (!userKey) return;
  try {
    localStorage.setItem(
      cacheKey(userKey),
      JSON.stringify({
        schemaVersion: 1,
        savedAt: new Date().toISOString(),
        etag: etag || "",
        activeTheme,
      })
    );
  } catch (error) {
    // A full or disabled storage must not break the classic UI fallback.
  }
}

function remove(userKey) {
  if (!userKey) return;
  try {
    localStorage.removeItem(cacheKey(userKey));
  } catch (error) {
    // Ignore unavailable storage.
  }
}

export default {
  read,
  write,
  remove,
};

